module.exports = __webpack_public_path__ + "static/media/product (13).ee73942b.jpg";